import { Badge } from "@/components/ui/baseUi/badge"
import { withForm } from "@/components/ui/forms/hooks/useFormHook"
import { Text } from "@/components/ui/baseUi/text"
import { coachFormDataDefaultValues } from "@/modules/coach/types/coachFormTypes"
import { word } from "@/modules/core/utils/i18n"

export const CoachCreationIntroStep = withForm({
  defaultValues: coachFormDataDefaultValues,
  render: function CoachCreationIntroStepInner() {
    return (
      <div className="flex flex-col gap-8">
        <div className="flex flex-col">
          <Text fontStyle="HM" className="font-bold text-textOnSurface-default">
            {word("coach.onboarding.intro.headline")}
          </Text>
          <Text fontStyle="BM" className="font-semibold text-textOnSurface-muted">
            {word("coach.onboarding.intro.description")}
          </Text>
          <Badge variant="primarySubtle" size="lg" className="mt-1 w-fit">
            <Text fontStyle="LM">{word("coach.onboarding.intro.badge")}</Text>
          </Badge>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {(
            [
              {
                num: 1,
                label: "coach.onboarding.intro.step1.label",
                desc: "coach.onboarding.intro.step1.description",
              },
              {
                num: 2,
                label: "coach.onboarding.intro.step2.label",
                desc: "coach.onboarding.intro.step2.description",
              },
              {
                num: 3,
                label: "coach.onboarding.intro.step3.label",
                desc: "coach.onboarding.intro.step3.description",
              },
            ] as const
          ).map(({ num, label, desc }) => (
            <div
              key={num}
              className="flex flex-col gap-1 rounded-2xl border border-dashed border-surface-border-gray-default p-6"
            >
              <Text fontStyle="DM" className="font-bold text-interactive-background-primary-default">
                {num}
              </Text>
              <Text fontStyle="TM" className="font-semibold text-textOnSurface-default">
                {word(label)}
              </Text>
              <Text fontStyle="BM" className="text-textOnSurface-default">
                {word(desc)}
              </Text>
            </div>
          ))}
        </div>
      </div>
    )
  },
})
